module.exports = __webpack_public_path__ + "img/0-16.c147198f.jpg";